const STORAGE_KEY = "billme_unsynced_bills_modal_snoozed_until";

function startOfTomorrow(): number {
	const date = new Date();
	date.setHours(24, 0, 0, 0);
	return date.getTime();
}

export function isUnsyncedBillsModalSnoozed(): boolean {
	const snoozedUntil = Number(localStorage.getItem(STORAGE_KEY));
	return Boolean(snoozedUntil) && Date.now() < snoozedUntil;
}

// Called as soon as the modal is shown (not just on a button click) so a
// dismiss via backdrop/escape still counts — the point is "seen once today",
// regardless of which way the user closes it.
export function snoozeUnsyncedBillsModal(): void {
	localStorage.setItem(STORAGE_KEY, String(startOfTomorrow()));
}
